<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <!-- {{ selection }} -->
                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-repeat text-primary mr-1"></i>
                                        Amend
                                        <b-badge id="selection" variant="primary" class="edit_tab">
                                            {{ selection.length }}</b-badge>
                                        <b-tooltip target="selection" placement="bottom">{{ selection.length }}
                                            inventory line(s) selected</b-tooltip>
                                    </div>

                                </template>

                                <p class="mt-2">
                                    <b-row class="my-2">

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="issued_at" v-model="issued_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="false" :showDropdowns="true"
                                                        :linkedCalendars="true" :single-date-picker="'true'"
                                                        :disabled="true">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="true"
                                                            @click="issued_at = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                                ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>



                                    <b-row class="mt-2">
                                        <b-col cols="12">
                                            <b-form-group label-cols="12" label="Transaction(s) selected"
                                                label-size="sm" class="mb-0">

                                                <b-input-group>
                                                    <b-form-tags input-id="referenceno" v-model="referenceno"
                                                        tag-variant="primary" separator=" ,;" placeholder="" size="sm"
                                                        class="h-29" add-button-text="+" add-on-change remove-on-delete
                                                        add-button-variant="outline-primary"
                                                        :disabled="true"></b-form-tags>

                                                    <b-input-group-append>
                                                        <b-button style="margin-top:-3px;" size="sm"
                                                            variant="outline-secondary" @click="referenceno = null"
                                                            :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <b-row class="mt-2">
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Type" label-size="sm">
                                                <treeselect placeholder="Type" v-model="type" :clearable="false"
                                                    :multiple="false" :options="options_type" :matchKeys="['id']"
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="yourref"
                                                        placeholder="Your Ref / PO" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="yourref = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <b-input-group class="treeselect_all justify-content-end pr-2px">
                                                    <span style="padding-top: 0.3em" class="text-primary"
                                                        id="slac-blocked">Blocked</span>
                                                    <b-form-checkbox id="slac-blocked-check" v-model="isslacblocked"
                                                        class="z-0">
                                                    </b-form-checkbox>
                                                </b-input-group>
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <b-input-group class="treeselect_all justify-content-end pr-2px">
                                                    <span style="padding-top: 0.3em" class="text-primary"
                                                        id="event-blocked">Blocked</span>
                                                    <b-form-checkbox id="event-blocked-check" v-model="iseventblocked"
                                                        class="z-0">
                                                    </b-form-checkbox>
                                                </b-input-group>
                                                <treeselect placeholder="Select event..." v-model="eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    searchPromptText="Type at least 4 chars..." :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Markup" label-for="markup" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="markup" placeholder="Markup"
                                                        size="sm"
                                                        :disabled="!user.permissions.includes('conferma.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('conferma.save')"
                                                            variant="outline-secondary" @click="markup = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Sale" label-for="sale" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="sale" placeholder="Sale"
                                                        size="sm"
                                                        :disabled="!user.permissions.includes('conferma.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('conferma.save')"
                                                            variant="outline-secondary" @click="sale = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="InvoiceNo" label-for="invoiceno" label-cols="12">
                                                <b-input-group class="treeselect_all" style="left:60px; top:-12px">
                                                    <i class="fa fa-info-circle" id="invoiceno"></i>
                                                </b-input-group>
                                                <b-tooltip target="invoiceno" triggers="hover" placement="bottom">Enter
                                                    the InvoiceNo for these card
                                                    charges or ATOLSALE on BCARDCONF to remove these.</b-tooltip>

                                                <b-input-group>
                                                    <b-form-input type="text" v-model="invoiceno"
                                                        placeholder="InvoiceNo" size="sm" :disabled="false"
                                                        list="invoiceno_opt-list"></b-form-input>
                                                    <datalist id="invoiceno_opt-list">
                                                        <option v-for="invoiceno_opt in invoicenos"
                                                            :key="invoiceno_opt">
                                                            {{ invoiceno_opt }}
                                                        </option>
                                                    </datalist>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="invoiceno = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>

                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Travellers" label-for="travellers" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="travellers"
                                                        placeholder="Travellers" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="travellers = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Route" label-for="routing" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="routing" placeholder="Route"
                                                        size="sm" :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="routing = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Remark" label-for="remark" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="remark" placeholder="Remark"
                                                        size="sm" :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="remark = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Status" label-size="sm">
                                                <treeselect placeholder="Status" v-model="status" :clearable="false"
                                                    :multiple="false" :options="options_status" :matchKeys="['id']"
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Agent" label-for="agent" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="agent" placeholder="Agent"
                                                        size="sm" :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="agent = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Grouping" label-size="sm">
                                                <treeselect placeholder="Grouping" v-model="grouping" :clearable="false"
                                                    :multiple="false" :options="options_grouping" :matchKeys="['id']"
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col> -->
                                    </b-row>
                                </p>
                            </b-tab>
                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col class="text-left">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="user.permissions.includes('carhire.admin')">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>

                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "CarHireAmend",
    async mounted() {
        await this.accessdenied();
        // this.ticketschange_load();
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            debounce: 500,
            readonly: false,
            referenceno: [],
            issued_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            yourref: null,
            slac: null,
            isslacblocked: false,
            blac: null,
            eventcode: null,
            iseventblocked: false,
            markup: null,
            sale: null,
            travellers: null,
            invoiceno: null,
            invoicenos: ["ATOLSALE"],
            remark: null,
            agent: null,
            routing: null,
            type: null,
            options_type: [
                { id: "AIR", label: "Air Ticketed" },
                { id: "CAR", label: "Cars" },
                { id: "HTL", label: "Hotels" },
                { id: "EMD", label: "EMD" },
                { id: "RAIL", label: "Rail/Eurostar" },
                { id: "XFR", label: "Transfers" },
                { id: "SEA", label: "Ferry" },

                // { id: "LOW", label: "Low Cost" },    
                // { id: "BAG", label: "Baggage" },
                // { id: "MTG", label: "Meetings" },
                // { id: "OTH", label: "Other" },
                // { id: "BMD", label: "Business" },
                // { id: "visa", label: "Visa" },
            ],
            status: null,
            options_status: [
                { id: "ready", label: "Ready" },
                { id: "pending", label: "Pending" },
                { id: "offline", label: "Offline" },
            ],
            // grouping: null,
            // options_grouping: [
            //     { id: "deployed", label: "Deployed" },
            //     { id: "manual", label: "Manual" },             
            // ],
        };
    },
    watch: {},
    methods: {
        async accessdenied() {

        },
        async load() {
            this.referenceno = []

            for (var i = 0; i < this.selection.length; ++i) {
                this.referenceno.push(this.selection[i].referenceno)
            }

        },

        async saveit() {
            this.busy = true;

            let rows = []
            for (var i = 0; i < this.selection.length; ++i) {
                let row = {
                    id: this.selection[i].id
                }
                if (this.type) {
                    row.type = this.type
                }
                if (this.yourref) {
                    row.yourref = this.yourref
                }
                if (this.slac) {
                    row.slac = this.slac
                }
                if (this.eventcode) {
                    row.eventcode = this.eventcode
                }
                if (this.blac) {
                    row.blac = this.blac
                }
                if (this.markup) {
                    row.markup = this.markup
                }
                if (this.sale) {
                    row.sale = this.sale
                }
                if (this.travellers) {
                    row.travellers = this.travellers
                }
                if (this.invoiceno) {
                    row.invoiceno = this.invoiceno
                }
                if (this.routing) {
                    row.routing = this.routing
                }
                if (this.remark) {
                    row.remark = this.remark
                }
                if (this.agent) {
                    row.agent = this.agent
                }
                if (this.status) {
                    row.status = this.status
                }
                // if (this.grouping) {
                //     row.grouping = this.grouping
                // }
                rows.push(row)
            }
            let variables = { rows }
            console.log(variables)

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation carhire_save($rows: [InventoryLine_input]) {
              carhire_save(rows: $rows) {
                    id
                    type
                    issued_at
                    referenceno
                    invoicetype
                    description                   
                    traveller
                    yourref                    
                    blac  
                    reference
                    cost                    
                    markup
                    sale  
                    quoted                                     
                    slac
                    eventcode             
                    agent
                    status
                    invoiceno   
                    blinvoiceno
                    cost
                    sale
                    # booker                    
                    startcity
                    start_at
                    end_at
                    endcity
                    startlocation
                    endlocation
                    cabin
                    equipment
                    reference
                    pax
                    traveller
                    notes
                    created_at
                    created_by
                    updated_at
                    updated_by
                    rows
              }
            }
          `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

    },
};
</script>